/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BucketWidth = {
  Onem: "1m",
  Oneh: "1h",
  Oned: "1d",
} as const;
export type BucketWidth = ClosedEnum<typeof BucketWidth>;

/** @internal */
export const BucketWidth$inboundSchema: z.ZodNativeEnum<typeof BucketWidth> = z
  .nativeEnum(BucketWidth);
/** @internal */
export const BucketWidth$outboundSchema: z.ZodNativeEnum<typeof BucketWidth> =
  BucketWidth$inboundSchema;
